import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStatuses from 'app/store/project/statuses/statuses.selectors';
import { OrderOutput, StatusOutput } from 'core/http/project';
import { ownedError } from 'core/utils/owned-error';
import { selectFirst } from 'core/utils/rx-common';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-current-status',
  templateUrl: './current-status.component.html',
  styleUrls: ['./current-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CurrentStatusComponent {
  private _order?: OrderOutput;

  @Input() skeletonView = false;

  @Input()
  set order(o: OrderOutput) {
    this._order = o;
  }

  get order(): OrderOutput {
    if (!this._order) {
      throw ownedError(new Error('Order was not initialized'));
    }

    return this._order;
  }

  get status$(): Observable<StatusOutput | undefined> {
    if (!this._order) {
      throw ownedError(new Error('Order was not initialized'));
    }

    return this.store$
      .pipe(
        selectFirst(fromStatuses.oneStatus, { id: this._order.statusId }),
      );
  }

  constructor(private store$: Store) {}
}
